import React, { Component } from "react";

class NoMatch extends Component {
  render() {
    return (
      <section className="section">
        <div className="container content">
          <div className="level level-item">
            <h1>404</h1>
          </div>
        </div>
      </section>
    );
  }
}

export default NoMatch;
